(function () {
  'use strict';

  function getPitch(viewport) {
    var slide = viewport.querySelector('[data-nh-slider-slide]');
    var track = viewport.querySelector('[data-nh-slider-track]');
    if (!slide || !track) return 0;
    return slide.offsetWidth + (parseFloat(window.getComputedStyle(track).gap) || 0);
  }

  function getState(slider) {
    var viewport = slider.querySelector('[data-nh-slider-viewport]');
    var slides = viewport ? viewport.querySelectorAll('[data-nh-slider-slide]') : [];
    var count = Math.max(0, slides.length - 2);
    return { viewport: viewport, count: count, pitch: viewport ? getPitch(viewport) : 0 };
  }

  function currentIndex(state) {
    if (!state.pitch || !state.count) return 0;
    return (Math.round(state.viewport.scrollLeft / state.pitch) - 1 + state.count) % state.count;
  }

  function rawIndex(state) {
    return state.pitch ? Math.round(state.viewport.scrollLeft / state.pitch) : 0;
  }

  function updateControls(slider, state) {
    var index = currentIndex(state);
    slider.querySelectorAll('[data-nh-slider-index]').forEach(function (control) {
      if (Number(control.dataset.nhSliderIndex) === index) control.setAttribute('aria-current', 'true');
      else control.removeAttribute('aria-current');
    });
  }

  function rebase(slider, state) {
    if (!state.pitch || !state.count) return;
    var rawIndex = Math.round(state.viewport.scrollLeft / state.pitch);
    if (rawIndex === 0) state.viewport.scrollLeft = state.count * state.pitch;
    if (rawIndex === state.count + 1) state.viewport.scrollLeft = state.pitch;
    updateControls(slider, getState(slider));
  }

  function goTo(slider, index, behavior) {
    var state = getState(slider);
    if (!state.viewport || !state.pitch || !state.count) return;
    var normalized = ((Number(index) % state.count) + state.count) % state.count;
    state.viewport.scrollTo({ left: (normalized + 1) * state.pitch, behavior: behavior || 'smooth' });
  }

  function goBy(slider, direction) {
    var state = getState(slider);
    if (!state.viewport || !state.pitch || !state.count) return;
    /* Keep the cloned first/last slide in the visible travel path, then rebase after it finishes. */
    state.viewport.scrollTo({ left: (rawIndex(state) + direction) * state.pitch, behavior: 'smooth' });
  }

  function initializeSlider(slider) {
    if (!slider || slider.dataset.nhSliderInitialized === 'true') return;
    var state = getState(slider);
    if (!state.viewport || state.count < 1) return;

    slider.dataset.nhSliderInitialized = 'true';
    var viewport = state.viewport;
    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    var startRawIndex = 0;
    var releaseTimer;
    var initialTimer;
    var userInteracted = false;

    function scheduleRebase() {
      window.clearTimeout(releaseTimer);
      releaseTimer = window.setTimeout(function () { rebase(slider, getState(slider)); }, 600);
    }

    function positionInitialSlide() {
      var initial = getState(slider);
      if (!initial.pitch) return;
      viewport.scrollTo({ left: initial.pitch, behavior: 'auto' });
      updateControls(slider, initial);
    }
    window.requestAnimationFrame(function () {
      positionInitialSlide();
      /* A layout shift during theme hydration can reset scrollLeft to a clone. Restore only before interaction. */
      initialTimer = window.setTimeout(function () {
        if (!userInteracted) positionInitialSlide();
      }, 700);
    });

    viewport.addEventListener('scroll', function () {
      updateControls(slider, getState(slider));
      if (!dragging) scheduleRebase();
    }, { passive: true });
    viewport.addEventListener('scrollend', function () { rebase(slider, getState(slider)); });
    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      userInteracted = true;
      window.clearTimeout(initialTimer);
      dragging = true;
      startX = event.clientX;
      startLeft = viewport.scrollLeft;
      startRawIndex = rawIndex(getState(slider));
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) event.preventDefault();
      viewport.scrollLeft = startLeft - delta;
    });
    function release(event) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (event && viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      var next = getState(slider);
      var delta = event ? event.clientX - startX : 0;
      var targetIndex = startRawIndex;
      /* One deliberate swipe always advances exactly one slide; a short drag snaps back. */
      if (Math.abs(delta) >= 24) targetIndex += delta < 0 ? 1 : -1;
      if (next.pitch) viewport.scrollTo({ left: targetIndex * next.pitch, behavior: 'smooth' });
      scheduleRebase();
    }
    viewport.addEventListener('pointerup', release);
    viewport.addEventListener('pointercancel', release);
    slider.addEventListener('click', function (event) {
      var control = event.target.closest('[data-nh-slider-index], [data-nh-slider-prev], [data-nh-slider-next]');
      if (!control || !slider.contains(control)) return;
      if (control.hasAttribute('data-nh-slider-prev')) goBy(slider, -1);
      else if (control.hasAttribute('data-nh-slider-next')) goBy(slider, 1);
      else goTo(slider, Number(control.dataset.nhSliderIndex));
      event.nhSliderHandled = true;
    });
  }

  window.NHQuizSlider = {
    initialize: function (root) {
      (root || document).querySelectorAll('[data-nh-slider]').forEach(initializeSlider);
    },
    goTo: goTo
  };
})();
